<template>
  <v-card class="prospects">
    <v-container fluid>
      <v-toolbar v-if="true" dense flat class="px-0">
        <v-btn small color="primary mr-4" @click="newProspect">New</v-btn>
        <!-- <v-spacer></v-spacer> -->
        <v-text-field
          v-if="false"
          dense
          v-model="firstname"
          type="text"
          label="Filter by first name"
          outlined
          hide-details
          append-icon="mdi-magnify"
          @input="getProspects"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-radio-group dense :hide-details="true" v-model="sortBy" :column="false" @change="getProspects">
          <v-radio color="primary" label="Event Date" value="start"></v-radio>
          <v-radio color="primary" label="Last Contact" value="lastContact"></v-radio>
        </v-radio-group>
      </v-toolbar>
      <v-row
          v-for="prospect in prospects"
          :key="prospect.id"
          cols="12"
          md="6"
          class="text-center mb-2 mt-0 item-box"
          align="center"
      >
            <v-col cols=3 class="py-0">
              {{ prospect.first }} {{ prospect.last }}
            </v-col>
            <v-col cols=5 class="py-0 secondary--text text-left">
              <v-row>
                <v-col class="py-1">
                  {{ prospect.event_type }}
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <v-icon>mdi-calendar-month</v-icon>
                  {{ showEventDate(prospect.start) }}
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-1">
                  <v-icon v-if="prospect.last_contact">mdi-phone-clock</v-icon>
                  {{ showEventDate(prospect.last_contact) }}
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <v-icon class="pr-2" @click="deleteProspect(prospect)" title="Delete prospect">mdi-trash-can</v-icon>
              <v-icon @click="editProspect(prospect)">mdi-pencil</v-icon>
              <v-spacer class="py-1" ></v-spacer>
              <v-btn x-small color="primary" @click="copyURL(prospect)">Signup Link</v-btn>
            </v-col>
            <!-- <v-col>
              <v-btn x-small color="primary" @click="copyURL(prospect)">Signup Link</v-btn>
            </v-col> -->
      </v-row>
            <!-- <v-row>
              <v-col cols="3" class="primary--text pr-0 text-truncate"><h4>Address</h4></v-col>
              <v-col>{{ prospect.street }}<br>{{ prospect.city }}, {{ prospect.state }} {{ prospect.zipcode }}</v-col>
            </v-row> -->
            <!-- <v-row>
              <v-col cols="3" class="primary--text pr-0 text-truncate"><h4>Start Date</h4></v-col>
              <v-col v-if="prospect.start">{{ showEventDate(prospect.start) }} {{ showEventTime(prospect.start)}}</v-col>
            </v-row> -->
    </v-container>

    <v-dialog v-model="prospectDlg" persistent :fullscreen="$vuetify.breakpoint.width < 501" xmax-width="390" overlay-opacity=.7>
      <v-card>
        <h4 class="pt-2 pb-0 mb-0 ml-4 primary--text"><v-icon color="primary" @click="exitProspect">mdi-close-circle</v-icon> Cancel</h4>
        <div class="text-center pt-0 pb-2 mb-0">
          <h2 v-if="editing" class="b-header">Edit Prospect</h2>
          <h2 v-else class="b-header">Add Prospect</h2>
        </div>
        <v-card-text>
          <v-form ref="form" v-model="validForm">
            <v-row class="text-left">
              <v-col class="mx-0 py-0 pt-4 primary--text"><h4>First Name <small>(required)</small></h4></v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" cols="12" md="4">
                <v-text-field
                  v-model="prospect.first"
                  type="text"
                  outlined
                  dense
                  :rules="nameRules"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="text-left">
              <v-col class="mx-0 py-0 pt-4 primary--text"><h4>Last Name <small>(required)</small></h4></v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" cols="12" md="4">
                <v-text-field
                  v-model="prospect.last"
                  type="text"
                  outlined
                  dense
                  :rules="nameRules"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- <v-row class="text-left">
              <v-col class="mx-0 py-0 primary--text"><h4>Street Address</h4></v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  v-model.trim="prospect.street"
                  type="text"
                  label=""
                  outlined
                  color="primary"
                  dense
                  class="f-rounded"
                  @change="dirty = true"
                  :xrules="streetRules"
                ></v-text-field>
              </v-col>
            </v-row> -->
            <!-- <v-row class="text-left">
              <v-col cols=6 class="mx-0 py-0 primary--text"><h4>ZIP code</h4></v-col>
              <v-col class="mx-0 py-0 primary--text"><h4>State</h4></v-col>
            </v-row>
            <v-row>
              <v-col cols=6 class="py-0">
                <v-text-field
                  v-model.trim="prospect.zipcode"
                  type="text"
                  label=""
                  outlined
                  color="primary"
                  dense
                  inputmode="numeric"
                  class="f-rounded"
                  @change="dirty = true"
                  @blur="autofillAddress"
                  :rules="zipcodeRules"
                  :error-messages="zipcodeErrors"
                  persistent-hint
                  hint="City and State from ZIP"
                  name="prospect-zipcode"
                ></v-text-field>
              </v-col>
              <v-col class="py-0">
                <v-text-field
                  v-model.trim="prospect.state"
                  type="text"
                  label=""
                  outlined
                  color="primary"
                  dense
                  class="f-rounded"
                  @change="dirty = true"
                ></v-text-field>
              </v-col>
            </v-row> -->
            <!-- <v-row class="text-left">
              <v-col class="mx-0 py-0 primary--text"><h4>City</h4></v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  v-model.trim="prospect.city"
                  type="text"
                  label=""
                  outlined
                  color="primary"
                  dense
                  class="f-rounded"
                  @change="dirty = true"
                ></v-text-field>
              </v-col>
            </v-row> -->
            <v-row class="text-left">
              <v-col class="mx-0 py-0 primary--text"><h4>Email</h4></v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" cols="12" md="4">
                <v-text-field
                  v-model="prospect.email"
                  type="text"
                  label=""
                  outlined
                  dense
                  :rules="emailRules"
                  name="prospect-email"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="text-left">
              <v-col class="mx-0 py-0 primary--text"><h4>Phone</h4></v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" cols="12" md="4">
                <v-text-field
                  v-model="prospect.cell_phone"
                  type="text"
                  label=""
                  outlined
                  dense
                  :rules="phoneRules"
                  inputmode="numeric"
                  name="prospect-cell_phone"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="text-left">
              <v-col class="mx-0 py-0 primary--text"><h4>Event Type</h4></v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" cols="12" md="6">
                <!-- <v-select v-model="prospect.event_type" :items="eventTypes" outlined dense :rules="eventTypeRules" @change="eventTypeChanged"></v-select> -->
                <v-select v-model="prospect.event_type" :items="eventTypes" outlined dense :rules="eventTypeRules"></v-select>
              </v-col>
            </v-row>
            <v-row class="text-left">
              <v-col class="mx-0 py-0 primary--text"><h4>Brand</h4></v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" cols="12" md="6">
                <!-- <v-select v-model="prospect.brand" :items="brandsentTypes" outlined dense :rules="eventTypeRules" @change="eventTypeChanged"></v-select> -->
                <v-select v-model="prospect.brand_id" :items="brands" outlined dense></v-select>
              </v-col>
            </v-row>
            <v-row class="text-left">
              <v-col class="mx-0 py-0 primary--text"><h4>Description</h4></v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" cols="12" md="6">
                <v-textarea
                  v-model="prospect.description"
                  type="text"
                  outlined
                  dense
                  auto-grow
                  counter
                  :rules="descriptionRules"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="mx-0 py-0 primary--text"><h4>Start Date/Time</h4></v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <datetime
                  v-model="prospect.start"
                  type="datetime"
                  input-id="start-datetime"
                  :week-start="7"
                  use12-hour
                  :minute-step="5"
                  placeholder="Click to choose"
                  input-style="border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: #A9A9A9; width: 100%;"
                ></datetime>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="mx-0 pt-4 pb-0 primary--text"><h4>End Date/Time</h4></v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <datetime
                  v-model="prospect.end"
                  type="datetime"
                  input-id="end-datetime"
                  :week-start="7"
                  use12-hour
                  :minute-step="5"
                  placeholder="Click to choose"
                  input-style="border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: #A9A9A9; width: 100%;"
                ></datetime>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="mx-0 pt-4 pb-0 primary--text"><h4>Last Contact</h4></v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <datetime
                  v-model="prospect.last_contact"
                  type="date"
                  input-id="last-contact-date"
                  :week-start="7"
                  use12-hour
                  :minute-step="5"
                  placeholder="Click to choose"
                  input-style="border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: #A9A9A9; width: 100%;"
                ></datetime>
              </v-col>
            </v-row>
            <v-row class="text-left">
              <v-col class="mx-0 pt-5 pb-0 primary--text"><h4>Budget</h4></v-col>
            </v-row>
            <v-row>
              <v-col cols=6 class="py-0" md="4">
                <v-text-field
                  v-model="prospect.budget"
                  type="decimal"
                  outlined
                  dense
                  inputmode="decimal"
                  :rules="budgetRules"
                  @blur="validateBudget"
                  @focus="selectText"
                ></v-text-field>
              </v-col>
            </v-row>


            <!-- <v-row class="text-left">
              <v-col class="mx-0 py-0 primary--text"><h4>Hospitality Policy</h4></v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" cols="12" md="6">
                <v-textarea
                  v-model="prospect.hospitality"
                  type="text"
                  outlined
                  dense
                  auto-grow
                  counter
                  :rules="hospitalityRules"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row class="text-left">
              <v-col class="mx-0 py-0 primary--text"><h4>Website</h4></v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" cols="12" md="4">
                <v-text-field
                  v-model="prospect.website_url"
                  type="text"
                  label=""
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="text-left">
              <v-col class="mx-0 py-0 primary--text"><h4>Timezone</h4></v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <div v-if="true">
                  <v-radio-group
                    v-model="prospect.timezone"
                    class="mt-0"
                  >
                    <v-radio
                      v-for="tz in timezones"
                      :key="tz.label"
                      :label="tz.label"
                      :value="tz.timezone"
                      color="primary"
                    ></v-radio>
                  </v-radio-group>
                </div>
              </v-col>
            </v-row> -->
            <!-- <v-row>
              <v-col cols=12>Form is {{ validForm ? 'valid' : 'invalid' }}</v-col>
            </v-row> -->
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-center xpb-6 xpx-4">
          <v-col cols=6><v-btn block zlarge color="white" style="10px" class="text-none" @click="exitProspect">Cancel</v-btn></v-col>
          <v-col cols=6><v-btn block zlarge color="primary" style="10px" class="text-none" :loading="loading" @click="saveProspect">Save</v-btn></v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import axios from "axios";
import bmutils from '../bmutils.js'

export default {
  name: 'prospects',
  components: {
    //HelloWorld
  },
	data() {
		return {
      firstname: '',
      sortBy: 'start',
      prospects: [],
      prospectDlg: false,
      dirty: false,
      loading: false,
      validForm: true,
      editing: false, // true if editing an existing prospect
      prospect: {
        brand_id: 0,
        agent_id: 0,
        first: '',
        last: '',
        street: '',
        city: '',
        state: '',
        zipcode: '',
        cell_phone: '',
        email: '',
        event_type: '',
        description: '',
        start: '',
        end: '',
        budget: '',
      },
      eventTypes: null,
      eventType: '',
      brands: null,
      emailRules: [
        value => !!value || 'Email is required.',
        value => value.indexOf('@') !== 0 || 'Email should have a username.',
        value => value.includes('@') || 'Email should include an @ symbol.',
        // value =>
        //   value.indexOf('.') - value.indexOf('@') > 1 ||
        //   'Email should contain a valid domain.',
        value => value.includes('.') || 'Email should include a period symbol.',
        value =>
          value.indexOf('.') <= value.length - 3 ||
          'Email should contain a valid domain extension.'
      ],
      nameRules: [
        value => !!value || 'Required.',
      ],
      // streetRules: [
      //   value => !!value || 'Required.',
      // ],
      // cityRules: [
      //   value => !!value || 'Required.',
      // ],
      // stateRules: [
      //   value => !!value || '2-character state code is required.',
      // ],
      // zipcodeRules: [
      //   value => !!value || 'Required.',
      //   value => /^[0-9]{5}$/.test(value) || 'ZIP must be 5 digits'
      // ],
      // zipcodeErrors: [],
      phoneRules: [
        value => !!value || 'Phone is required.',
        value => value.length <= 16 || 'Max 16 characters',
      ],
      eventTypeRules: [
        value => !!value || 'Event type is required.',
      ],
      descriptionRules: [
        (v) => !!v || 'Description is required',
        (v) => v.length <= 2048 || 'Max 2048 characters'
      ],
      budgetRules: [
        value => !!value || 'Budget is required.',
      ],
    }
  },
  mounted() {
    this.initialize()
  },
  computed: {
    isAgent() {
      // is the logged-in user an agent?
      return this.$store.state.user && this.$store.state.user.is_agent
    },
    isAdmin() {
      // is the logged-in user an admin?
      return this.$store.state.user && this.$store.state.user.is_admin
    },
    apiErrorMsg: function() {
      return this.$store.state.apiError.userMessage
    }
  },
  methods: {
    async initialize() {
      if(!this.$store.state.user) {
        await this.$store.dispatch('getUser')
      }
      await this.getEventTypes()
      await this.getBrands()
      await this.getProspects()
      // this.getTimezones()
      if(!this.isAgent && !this.isAdmin) {
        this.$router.push('home')
        return
      }
    },
    newProspect() {
      if(this.$refs.form) {
        this.$refs.form.resetValidation()
      }
      this.prospect =  {
        // id: 0,
        brand_id: 0,
        agent_id: this.$store.state.user.agent.id,
        first: '',
        last: '',
        street: '',
        city: '',
        state: '',
        zipcode: '',
        cell_phone: '',
        email: '',
        event_type: '',
        description: '',
        start: '',
        end: '',
        last_contact: '',
        budget: '',
      }
      this.editing = false
      this.prospectDlg = true
    },
    editProspect(prospect) {
      this.prospect =  {
        id: prospect.id,
        brand_id: prospect.brand_id,
        agent_id: prospect.agent_id,
        first: prospect.first,
        last: prospect.last,
        street: prospect.street,
        city: prospect.city,
        state: prospect.state,
        zipcode: prospect.zipcode,
        cell_phone: prospect.cell_phone,
        email: prospect.email,
        event_type: prospect.event_type,
        description: prospect.description,
        start: prospect.start,
        end: prospect.end,
        last_contact: prospect.last_contact,
        budget: prospect.budget,
      }
      this.editing = true
      this.prospectDlg = true
    },
    prepaid(eventType) {
      return 'prepaid' == bmutils.paymentTiming(eventType)
    },
    exitProspect() {
      document.getElementsByClassName('v-dialog v-dialog--active')[0].scrollTop = 0
      // document.getElementsByClassName('dialog dialog--active')[0].scrollTop = 0
      this.editing = false
      this.prospectDlg = false
    },
    saveProspect() {
      if(!this.$refs.form.validate()) {
        this.$emit('error', "Please correct fields")
        return
      }
      if(!this.gotDatetimes()) {
        this.$emit('error', "Event start or end time needed")
        return
      }
      if(this.editing) {
        this.updateProspect()
      } else {
        this.addProspect()
      }
    },
    gotDatetimes() {
      // datetime doesn't do Vuetify rules
      // alert(this.prospect.start + ' ' + this.prospect.end)
      if(this.prepaid) {
        return this.prospect.start && this.prospect.end
      }
      return true
    },
    async getEventTypes() {
      this.$store.commit('SET_LOADING_STATUS', true);
      this.loading = true
      try {
        let result = await axios.get("event-types");
        // console.log(result);
        // this.eventTypes = [{text: 'No selection', value: 0}];
        this.eventTypes = [];
        result.data.forEach(el => {
          this.eventTypes.push(el)
        });
      } catch(err) {
        //console.log(err)
      }
      this.$store.commit('SET_LOADING_STATUS', false);
      this.loading = false
    },
    async getBrands() {
      this.$store.commit('SET_LOADING_STATUS', true);
      this.loading = true
      try {
        let result = await axios.get("brands");
        // console.log(result);
        // this.eventTypes = [{text: 'No selection', value: 0}];
        this.brands = [{text: 'No selection', value: 0}];
        result.data.forEach(el => {
          this.brands.push({
            text: el.name,
            value: el.id
          })
        });
      } catch(err) {
        //console.log(err)
      }
      this.$store.commit('SET_LOADING_STATUS', false);
      this.loading = false
    },
    async getProspects() {
      this.$store.commit('SET_LOADING_STATUS', true);
      this.loading = true
      try {
        let url = 'prospects'
        let qs = ''
        if(this.sortBy === 'start') {
          qs = 'sort_by=start_date&order=asc'
        }
        if(this.sortBy === 'lastContact') {
          qs = 'sort_by=last_contact_date&order=asc'
        }
        if(this.firstname != null && this.firstname.trim() != '') {
          if(qs) {
            qs += '&'
          }
          qs += 'name=' + this.firstname.trim()
        }
        if(qs) {
          url += '?' + qs
        }
        let result = await axios.get(url);
        this.prospects = []
        result.data.forEach(el => {
          this.prospects.push(el)
        });
      } catch(err) {
        // console.log(err)
        this.$emit('error', "Could not get prospects")
      }
      this.$store.commit('SET_LOADING_STATUS', false);
      this.loading = false
    },
    // async getTimezones() {
    //   this.$store.commit('SET_LOADING_STATUS', true);
    //   this.loading = true
    //   try {
    //     let result = await axios.get("timezones");
    //     this.timezones = []
    //     result.data.forEach(el => {
    //       this.timezones.push(el)
    //     });
    //   } catch(err) {
    //     //console.log(err)
    //   }
    //   this.$store.commit('SET_LOADING_STATUS', false);
    //   this.loading = false
    // },
    async autofillAddress() {
      if(this.prospect.zipcode == '') {
        return
      }
      await this.$store.dispatch('validateZipcode', {'zipcode': this.prospect.zipcode})
      if(this.$store.state.zipcode) {
        this.prospect.city = this.$store.state.zipcode.city
        this.prospect.state = this.$store.state.zipcode.state
        this.zipcodeErrors = []
      } else {
        this.zipcodeErrors = 'ZIP not found'
      }
    },
    async addProspect() {
      this.loading = true
      try {
        let result = await axios.post("prospects", this.prospect);
        this.prospect = result.data
        this.$emit('success', "Prospect added")
        this.prospectDlg = false
        this.dirty = false
        document.getElementsByClassName('v-dialog v-dialog--active')[0].scrollTop = 0 // fix
        await this.getProspects()
      } catch(err) {
        //console.log(err)
        this.$emit('error', "Could not save prospect")
      }
      this.$store.commit('SET_LOADING_STATUS', false);
      this.loading = false
    },
    async updateProspect() {
      this.loading = true
      try {
        let result = await axios.put("prospects/" + this.prospect.id, this.prospect);
        this.prospect = result.data
        this.$emit('success', "Prospect updated")
        this.prospectDlg = false
        this.dirty = false
        document.getElementsByClassName('v-dialog v-dialog--active')[0].scrollTop = 0 // fix
        await this.getProspects()
      } catch(err) {
        //console.log(err)
        this.$emit('error', "Could not save prospect")
      }
      this.loading = false
    },
    async deleteProspect(prospect) {
      let ok = confirm('Delete prospect ' + prospect.first + ' ' + prospect.last + '?') // TODO: need better confirmation dialog?
      if(!ok) {
        return
      }
      this.$store.commit('SET_LOADING_STATUS', true);
      this.loading = true
      try {
        await axios.delete("prospects/" + prospect.id);
        this.$emit('success', "Prospect deleted")
        await this.getProspects()
      } catch(err) {
        // console.log('deleteProspect: err', err)
        this.$emit('error', "Could not delete prospect")
      }
      this.$store.commit('SET_LOADING_STATUS', false);
      this.loading = false
    },
    showEventDate(t) {
      return bmutils.showDate(bmutils.isoToDatetime(t))
    },
    showEventTime(t) {
      return bmutils.showTime(bmutils.isoToDatetime(t))
    },
    formatPhone(cell_phone) {
      return bmutils.formatCell(cell_phone)
    },
    selectText(event) {
      event.target.select()
    },
    validateBudget() {
      this.prospect.budget = this.validateRate(this.prospect.budget)
    },
    validateRate(rate) {
      let amt = parseFloat(rate)
      if(isNaN(amt)) {
        amt = 0
      }
      return amt.toFixed(2) // round to nearest two decimal places and convert to string
    },
    copyURL(prospect) {
      let url = this.$store.state.appBaseURL + 'signupclient?p=' + prospect.id + '&ag=' + prospect.agent_id
      if(prospect.brand_id > 0) {
        url += '&b=' + prospect.brand_id
      }
      if(navigator.clipboard) {
        navigator.clipboard.writeText(url)
          .then(() => {
            this.$emit('success', 'Signup link copied to clipboard');
          })
          .catch(() => { // was catch(err => {
            alert(url)
            // alert('Here is the link: ' + url)
            //console.log(err)
            // this.$emit('info', "Could not copy link." + err)
          });
      } else {
        alert(url)
        // alert('Here is the link: ' + url)
        // this.$emit('info', "Clipboard not available")
      }
    }
  }
}

</script>

<style scoped>
.item-box {
  border-radius: 4px;
  border: 1px solid #CECECE;
}
</style>
